import { useEffect, useRef } from 'react'

const useThrottle = () => {
  const throttleSeed = useRef<null | ReturnType<typeof setTimeout>>(null)
  const pendingCallback = useRef<null | (() => void)>(null)

  const throttleFunction = useRef((callback: () => void, delay = 200) => {
    if (!throttleSeed.current) {
      callback()
      throttleSeed.current = setTimeout(() => {
        throttleSeed.current = null
        if (pendingCallback.current) {
          const trailingCallback = pendingCallback.current
          pendingCallback.current = null
          throttleFunction.current(trailingCallback, delay)
        }
      }, delay)
    } else {
      pendingCallback.current = callback
    }
  })

  useEffect(
    () => () => {
      if (throttleSeed.current) clearTimeout(throttleSeed.current)
      throttleSeed.current = null
      pendingCallback.current = null
    },
    [],
  )

  return throttleFunction.current
}

export default useThrottle
